module.exports = __webpack_public_path__ + "img/9788992309257.b682ac8f.jpg";